/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface NotificationTypeDto
 */
export interface NotificationTypeDto {
    /**
     *
     * @type {string}
     * @memberof NotificationTypeDto
     */
    type?: NotificationTypeDtoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof NotificationTypeDto
     */
    description?: string;
    /**
     *
     * @type {boolean}
     * @memberof NotificationTypeDto
     */
    isEnabled?: boolean;
}

/**
 * @export
 */
export const NotificationTypeDtoTypeEnum = {
    Unknown: "Unknown",
    FaultedStateDevice: "FaultedStateDevice",
    OfflineStateDevice: "OfflineStateDevice",
    UnknownStateDevice: "UnknownStateDevice",
    NonOperationalDevice: "NonOperationalDevice",
    EnergyPriceChargingSuspended: "EnergyPriceChargingSuspended",
    EnergyPriceChargingResumed: "EnergyPriceChargingResumed",
    Warning: "Warning",
    FrequentFaultsWarning: "FrequentFaultsWarning",
    ShortDurationWarning: "ShortDurationWarning",
    NoActivityWarning: "NoActivityWarning",
    ZerokWhWarning: "ZerokWhWarning",
    PowerLossWarning: "PowerLossWarning",
    LowEnergyMidSessionWarning: "LowEnergyMidSessionWarning",
} as const;
export type NotificationTypeDtoTypeEnum =
    (typeof NotificationTypeDtoTypeEnum)[keyof typeof NotificationTypeDtoTypeEnum];

/**
 * Check if a given object implements the NotificationTypeDto interface.
 */
export function instanceOfNotificationTypeDto(
    value: object,
): value is NotificationTypeDto {
    return true;
}

export function NotificationTypeDtoFromJSON(json: any): NotificationTypeDto {
    return NotificationTypeDtoFromJSONTyped(json, false);
}

export function NotificationTypeDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): NotificationTypeDto {
    if (json == null) {
        return json;
    }
    return {
        type: json["type"] == null ? undefined : json["type"],
        description:
            json["description"] == null ? undefined : json["description"],
        isEnabled: json["isEnabled"] == null ? undefined : json["isEnabled"],
    };
}

export function NotificationTypeDtoToJSON(
    value?: NotificationTypeDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        type: value["type"],
        description: value["description"],
        isEnabled: value["isEnabled"],
    };
}
